import { Path, Svg } from 'react-native-svg'

// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import { createIcon } from '../factories/createIcon'

export const [InfoCircle, AnimatedInfoCircle] = createIcon({
  name: 'InfoCircle',
  getIcon: (props) => (
    <Svg viewBox="0 0 16 16" fill="none" {...props}>
      <Path
        d="M7.99992 1.33325C4.31792 1.33325 1.33325 4.31792 1.33325 7.99992C1.33325 11.6819 4.31792 14.6666 7.99992 14.6666C11.6819 14.6666 14.6666 11.6819 14.6666 7.99992C14.6666 4.31792 11.6819 1.33325 7.99992 1.33325ZM8.49992 10.9999C8.49992 11.2759 8.27592 11.4999 7.99992 11.4999C7.72392 11.4999 7.49992 11.2759 7.49992 10.9999V7.95256C7.49992 7.67656 7.72392 7.45256 7.99992 7.45256C8.27592 7.45256 8.49992 7.67656 8.49992 7.95256V10.9999ZM8.01327 6.33325C7.64527 6.33325 7.34318 6.03459 7.34318 5.66659C7.34318 5.29859 7.63859 4.99992 8.00659 4.99992H8.01327C8.38193 4.99992 8.67993 5.29859 8.67993 5.66659C8.67993 6.03459 8.38127 6.33325 8.01327 6.33325Z"
        fill="currentColor"
      />
    </Svg>
  ),
})
